import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Conversations from './views/Conversations';
import NewChat from './views/NewChat';
import ReservationDetail from './views/ReservationDetails';

const base = (path = '') => `/access/chat${path}`;

export default () => (
  <Switch>
    <Route exact path={base()} component={Conversations} />
    <Route exact path={base('/tab/:tab_id')} component={Conversations} />
    <Route exact path={base('/new_chat')} component={NewChat} />
    <Route exact path={base('/:reservationId/details')} component={ReservationDetail} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/views/chat/router.js